import { render, staticRenderFns } from "./TrainCategory.vue?vue&type=template&id=77fc44b8&scoped=true&"
import script from "./TrainCategory.vue?vue&type=script&lang=js&"
export * from "./TrainCategory.vue?vue&type=script&lang=js&"
import style0 from "./TrainCategory.vue?vue&type=style&index=0&id=77fc44b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc44b8",
  null
  
)

export default component.exports